import styled from "styled-components";
import {hexToRgba} from "../../../themes/hex-to-rgba";
import {OverlayComponentDefaultBox} from "./overlay.component.default.box";

export const OverlayComponentMrGreenBox = styled(OverlayComponentDefaultBox)`
    background-color: ${props => hexToRgba(props.theme.colors.gameModeRealBackground, 0.85)};
`;
